"use strict";
var ReactDOMFeatureFlags = {
  useCreateElement: false
};
module.exports = ReactDOMFeatureFlags;
